interface KeypadProps {
  onKey: (key: string) => void;
  onDelete: () => void;
}

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0", "del"];

export default function Keypad({ onKey, onDelete }: KeypadProps) {
  return (
    <div className="grid grid-cols-3 px-4 shrink-0">
      {KEYS.map((key) => (
        <button
          key={key}
          type="button"
          aria-label={key === "del" ? "Delete" : key}
          onClick={() => (key === "del" ? onDelete() : onKey(key))}
          className="h-12 md:h-16 flex items-center justify-center rounded-2xl text-[24px] md:text-[26px] font-sans font-bold text-foreground-950 cursor-pointer select-none transition-colors active:bg-secondary-100"
        >
          {key === "del" ? (
            <i className="fa-solid fa-delete-left text-[24px]" />
          ) : (
            key
          )}
        </button>
      ))}
    </div>
  );
}